module.exports = __webpack_public_path__ + "img/BUY.2d58a209.svg";